var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "container-fluid p-0 vh-100 login d-flex align-items-center",
        },
        [
          _c(
            "div",
            { staticClass: "w-100 py-3" },
            [
              _c(
                "BCard",
                {
                  staticClass: "mx-auto bg-transparent border-0",
                  staticStyle: { "max-width": "600px" },
                },
                [
                  _c("BCardTitle", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(_vm.$t("Sign in"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "BForm",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.login.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "BTabs",
                        { attrs: { pills: "", "content-class": "mt-3" } },
                        [
                          _c(
                            "BTab",
                            {
                              attrs: {
                                title: _vm.$t("Using your Connect account"),
                                active: "",
                              },
                            },
                            [
                              _c(
                                "BFormGroup",
                                [
                                  _c(
                                    "BInputGroup",
                                    [
                                      _c(
                                        "BInputGroupPrepend",
                                        { attrs: { "is-text": "" } },
                                        [_c("BIconPersonFill")],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("BFormInput", {
                                        attrs: {
                                          placeholder: _vm.$t("E-mail address"),
                                        },
                                        model: {
                                          value: _vm.username,
                                          callback: function ($$v) {
                                            _vm.username = $$v
                                          },
                                          expression: "username",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "BFormGroup",
                                [
                                  _c(
                                    "BInputGroup",
                                    [
                                      _c(
                                        "BInputGroupPrepend",
                                        { attrs: { "is-text": "" } },
                                        [_c("BIconLockFill")],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("BFormInput", {
                                        attrs: {
                                          placeholder: "******",
                                          type: "password",
                                        },
                                        model: {
                                          value: _vm.password,
                                          callback: function ($$v) {
                                            _vm.password = $$v
                                          },
                                          expression: "password",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "BTab",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "Using your Active Directory account"
                                ),
                              },
                            },
                            [
                              _c(
                                "BFormGroup",
                                [
                                  _c(
                                    "BInputGroup",
                                    [
                                      _c(
                                        "BInputGroupPrepend",
                                        { attrs: { "is-text": "" } },
                                        [_c("BIconPersonFill")],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("BFormInput", {
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "Active Directory username"
                                          ),
                                        },
                                        model: {
                                          value: _vm.username,
                                          callback: function ($$v) {
                                            _vm.username = $$v
                                          },
                                          expression: "username",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "BFormGroup",
                                [
                                  _c(
                                    "BInputGroup",
                                    [
                                      _c(
                                        "BInputGroupPrepend",
                                        { attrs: { "is-text": "" } },
                                        [_c("BIconLockFill")],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("BFormInput", {
                                        attrs: {
                                          placeholder: "******",
                                          type: "password",
                                        },
                                        model: {
                                          value: _vm.password,
                                          callback: function ($$v) {
                                            _vm.password = $$v
                                          },
                                          expression: "password",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("BFormGroup", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-block",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(_vm._s(_vm.$t("Sign in")))]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col text-center" },
                      [
                        _c(
                          "BLink",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.modal-register",
                                modifiers: { "modal-register": true },
                              },
                            ],
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Don't have an account yet? Register here"
                                )
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "BLink",
                          {
                            staticClass: "ml-4",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.requestPasswordReset()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Forgot your password?")) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "BModal",
        {
          attrs: {
            id: "modal-register",
            title: _vm.$t("Register"),
            "ok-title": _vm.$t("Send"),
            size: "lg",
          },
          on: {
            ok: function ($event) {
              $event.preventDefault()
              return _vm.register()
            },
          },
        },
        [
          _c("Register", {
            ref: "component-register",
            on: {
              registrationSuccessful: function ($event) {
                return _vm.$bvModal.hide("modal-register")
              },
            },
            model: {
              value: _vm.user,
              callback: function ($$v) {
                _vm.user = $$v
              },
              expression: "user",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BModal",
        {
          ref: "modal-resetPassword",
          attrs: {
            title: _vm.$t("Reset your password"),
            "ok-title": _vm.$t("Save"),
            size: "lg",
          },
          on: {
            ok: function ($event) {
              $event.preventDefault()
              return _vm.resetPassword.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "BForm",
            { ref: "form-resetPassword" },
            [
              _c(
                "BFormGroup",
                { attrs: { label: _vm.$t("Password"), "label-cols": "3" } },
                [
                  _c("BFormInput", {
                    attrs: { type: "password", required: "" },
                    model: {
                      value: _vm.reset_password_data.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.reset_password_data, "password", $$v)
                      },
                      expression: "reset_password_data.password",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "BFormGroup",
                {
                  attrs: {
                    label: _vm.$t("Confirm password"),
                    "label-cols": "3",
                  },
                },
                [
                  _c("BFormInput", {
                    attrs: { type: "password", required: "" },
                    model: {
                      value: _vm.reset_password_data.password_confirm,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.reset_password_data,
                          "password_confirm",
                          $$v
                        )
                      },
                      expression: "reset_password_data.password_confirm",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AxiosErrorInterceptor"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("nav", { staticClass: "navbar navbar-light fixed-top login" }, [
      _c("a", { staticClass: "navbar-brand", attrs: { href: "#" } }, [
        _c("img", {
          staticStyle: { height: "1em", "margin-bottom": ".1em" },
          attrs: { src: require("../img/logo.svg") },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }